import PartnerDirectory from "../components/PartnerDirectory";
import { Scale, FileCheck, Gavel, Users } from "lucide-react";

const FEATURES = [
    { icon: FileCheck, title: "Title Verification", desc: "30+ year title chain checks, encumbrance certificates, and approvals." },
    { icon: Scale, title: "Agreement Drafting", desc: "Sale deed, lease deed, MoU, and gift deed drafting by qualified advocates." },
    { icon: Gavel, title: "Registry Support", desc: "End-to-end stamp duty, e-stamping, and sub-registrar coordination." },
    { icon: Users, title: "Legal Consultation", desc: "1-on-1 sessions for disputes, RERA filings, and inheritance matters." },
];

export default function Advocates() {
    return (
        <PartnerDirectory
            role="advocate"
            roleLabel="Property Advocates"
            roleLabelSingular="Property Advocate"
            path="/advocates"
            heroTag="Legal Services"
            heroTitle={<>Property law, <span className="text-gold-500">simplified.</span></>}
            heroSubtitle="Verified property advocates handle every legal step — from title checks to registry. Bar Council registered, with proven track records across Maharashtra."
            features={FEATURES}
            jsonLdCategory="LegalService"
        />
    );
}
